"use client";

import { Pagination } from "@/components/ui/pagination";

interface ProjectsListFooterProps {
  total: number;
  page: number;
  totalPages: number;
  onPageChange: (page: number) => void;
  loading: boolean;
  paginationDisabled: boolean;
}

export function ProjectsListFooter({
  total,
  page,
  totalPages,
  onPageChange,
  loading,
  paginationDisabled,
}: ProjectsListFooterProps) {
  return (
    <div className="flex shrink-0 items-center justify-between border-t border-border px-page py-3">
      <span
        aria-hidden="true"
        className="hidden sm:block text-sm text-contrast/50"
      >
        {loading ? "..." : `${total} project${total !== 1 ? "s" : ""}`}
      </span>
      <Pagination.Root
        page={page}
        totalPages={totalPages}
        onPageChange={onPageChange}
        disabled={paginationDisabled}
        variant="list"
      >
        <Pagination.Nav>
          <Pagination.First />
          <Pagination.Prev mode="icon" />
          <span aria-hidden="true" className="text-xs text-contrast/40 px-1">
            Prev
          </span>
          <Pagination.Pages strategy="current" />
          {totalPages > 1 && (
            <span
              aria-hidden="true"
              className="text-xs text-contrast/30 px-0.5"
            >
              of {totalPages}
            </span>
          )}
          <span aria-hidden="true" className="text-xs text-contrast/40 px-1">
            Next
          </span>
          <Pagination.Next mode="icon" />
          <Pagination.Last />
        </Pagination.Nav>
      </Pagination.Root>
    </div>
  );
}
